import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const plotApi = createApi({
  reducerPath: 'plotApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['Plot', 'PlotList'],
  endpoints: () => ({})
})

export default plotApi
